import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem, MessageService } from 'primeng/api';
import { DashboardService } from 'src/app/services/dashboard.service';
import { ReportsService } from 'src/app/services/reports.service';
import { first } from 'rxjs';
import saveAs from 'file-saver';
import { Stage1Subsidy } from 'src/app/models/department-reports.model';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { shareReplay } from 'rxjs/operators';
import { BaseService } from 'src/app/services/common/base.service';
import { Table } from 'primeng/table';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
@Component({
  selector: 'app-rtf-lot-report',
  templateUrl: './rtf-lot-report.component.html',
  styleUrls: ['./rtf-lot-report.component.scss'],
})
export class RtfLotReportComponent implements OnInit {
  @ViewChild('dataTable', { static: true })
  public dataTable: Table;
  rtf_lot_report: any[];
  appVerificationItems: MenuItem[];
  appVerificationModel: Stage1Subsidy[];
  filteredDataForExport: any = [];
  cols: (
    | { field: string; header: string; customExportHeader: string }
    | { field: string; header: string; customExportHeader?: undefined }
  )[];
  exportColumns: { title: string; dataKey: string }[];
  public filteredData: any = [];
  public totalSelectedApp: any = 0;
  public totalSubToFarmer: any = 0;
  public totalSubToVendor: any = 0;
  public totalFarmerRefund: any = 0;

  public userID: any;
  routePath: any;
  subjectSub: any;
  selectedYear: any;
  public subscriptions: any = [];
  public loading: boolean = false;
  constructor(
    private reportsService: ReportsService,
    private messageService: MessageService,
    private dashboard: DashboardService,
    private router: Router,
    private activityRecordService: ActivityRecordService,
    private loader: AppLoaderService,
    private service: BaseService,
    private cryptoJsService: CryptoJsService
  ) {}

  ngOnInit(): void {
    if (sessionStorage.getItem('financialYear')) {
      this.service.changeFinancialYear(sessionStorage.getItem('financialYear'));
    }
    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    this.userID = JSON.parse(payload)?.sub;

    this.appVerificationItems = [
      {
        label: 'Download excel',
        icon: 'pi pi-fw pi-download',
        command: () => {
          this.exportExcel(this.appVerificationModel, 'RTF_Lot_Report');
        },
      },
      // {
      //   label: 'Download Pdf', icon: 'pi pi-fw pi-download', command: () => {
      //     this.downloadSheetAsPdf(this.appVerificationModel, "RTF_lot_report");
      //   }
      // },
    ];

    this.loadDataAndApplyFilter();
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
    if (this.subjectSub) {
      this.subjectSub.unsubscribe();
    }
  }

  loadDataAndApplyFilter() {
    if (sessionStorage.getItem('financialYear')) {
      this.service.changeFinancialYear(sessionStorage.getItem('financialYear'));
    }

    this.subjectSub = this.service
      .getSelectedYear()
      .pipe(shareReplay())
      .subscribe((res) => {
        this.selectedYear = res;
        this.loadData();
        this.dataTable.filters['Fin_Year'] = [
          {
            value: this.selectedYear,
            matchMode: 'startsWith',
            operator: 'and',
          },
        ];
      });
  }

  loadData() {
    // this.loader.start();
    this.loading = true;
    let sub = this.reportsService
      .getConsolidatedLotRpt('RTF')
      .pipe(first())
      .subscribe({
        next: (data) => {
          // this.loader.close();
          this.loading = false;
          this.activityRecordService.activityRecord(
            this.userID,
            'RTF Lot Report',
            '',
            new Date(),
            'Success'
          );
          // this.loader.close();
          this.loading = false;
          if (data?.length > 0) {
            this.rtf_lot_report = data;
            this.appVerificationModel = data;
          } else {
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: 'Data Not Available',
            });
            this.rtf_lot_report = [];
            this.appVerificationModel = [];
          }
        },
        error: (err) => {
          // this.loader.close();
          this.loading = false;
          this.activityRecordService.activityRecord(
            this.userID,
            'RTF Lot Report',
            '',
            new Date(),
            err
          );

          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
    this.subscriptions.push(sub);
  }

  exportExcel(modelData, filename) {
    if (!modelData) {
      modelData = [];
    }
    import('xlsx').then((xlsx) => {
      let dataToSave = modelData.map((d: any) => {
        return {
          'Lot No': d.Lot_No,
          'App ID': d.AppID,
          'Application Type': d.ApplicationType,
          'Program Name': d.Program_Name,
          'Refund to Farmer': d.Refund_to_Farmer,
          'Created Date': d.CreatedDate,
          'PFMS Payment Date': d.PFMSPaymentDate,
          Status: d.Status,
          Remarks: d.Remarks,
          'Financial Year': d.Fin_Year,
        };
      });

      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: 'xlsx',
        type: 'array',
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }
  saveAsExcelFile(buffer: any, fileName: string): void {
    import('file-saver').then((FileSaver) => {
      let EXCEL_TYPE =
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      let EXCEL_EXTENSION = '.xlsx';
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE,
      });
      saveAs(
        data,
        fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  }

  // downloadSheetAsPdf(modelData, filename) {
  //   this.cols = [
  //     { field: 'Lot_No', header: 'Lot No' },
  //     { field: 'AppID', header: 'AppID' },
  //     { field: 'ApplicationType', header: 'ApplicationType' },
  //     { field: 'Program_Name', header: 'Program_Name ID' },
  //     { field: 'Refund_to_Farmer', header: 'Refund to Farmer' },
  //     { field: 'CreatedDate', header: 'CreatedDate' },
  //     { field: 'PFMSPaymentDate', header: 'PFMSPaymentDate' },
  //     { field: 'Status', header: 'Status' },
  //     { field: 'Remarks', header: 'Remarks' },
  //     { field: 'Fin_Year', header: 'Fin_Year' },
  //   ];

  //   this.exportColumns = this.cols.map((col) => ({
  //     title: col.header,
  //     dataKey: col.field,
  //   }));

  //   import('jspdf').then((jsPDF) => {
  //     import('jspdf-autotable').then((x) => {
  //       const doc = new jsPDF.default(0, 0);
  //       doc.autoTable(this.exportColumns, modelData);
  //       doc.save(`${filename}.pdf`);
  //     });
  //   });
  // }
}
